import { DEFAULT_FIRST_GET_DATA_AMOUNT, DEFAULT_ROWS_PER_PAGE } from '../../../config-global';
import { useEffect, useState, useRef, createRef } from 'react';
import axios from '../../../lib/axios';
import {
  MASTER_CATEGORIES_FIND_MANY,
  MASTER_DIVISION_FIND_MANY,
  MASTER_MAIN_GROUP_FIND_MANY,
  MASTER_SUB_CATEGORIES_FIND_MANY,
} from '../../../lib/endpoints/category';
import {
  GET_COUNT_MASTER_PRODUCT,
  GET_PRODUCT_FROM_SBC,
  MASTER_PRODUCT_UPDATE,
  MASTER_PRODUCT_UPDATE_MASTER_PRODUCT_CATEGORY,
  PRODUCTS_BRAND_FIND_MANY,
  PRODUCT_MASTER_FIND_MANY,
  PRODUCT_MASTER_GET_PRODUCT_ON_HAND_FROM_SBC,
  REFRESH_PRODUCT_MERCHANT,
} from '../../../lib/endpoints/product';
import { BrandModel } from '../../../models/brand';
import { MasterProductModel } from '../../../models/masterProduct';
import { SuppliesMainGroupName } from '../../../models/suppliesMain';
import { SuppliesDivisionModel } from '../../../models/suppliesDivisionModel';
import { SuppliesCategoryProduct } from '../../../models/suppliesCategoryProduct';
import { SuppliesProductSubCategory } from '../../../models/suppliesSubCategory';
import { MERCHANT_STORE_FIND_MANY } from '../../../lib/endpoints/merchant';
import { MerChantModel } from '../../../models/merChantModel';
import { concatenateStrings } from '../../../utils/concatenateStrings';
import {
  getCategoryActiveProduct,
  getCountMasterProduct,
  getProduct,
  getProductById,
  searchMasterProduct,
  uploadMultipleImage,
} from '../../../services/product';
import { getMasterMainGroup } from '../../../services/masterMainGroup';
import { getAllMasterDivision, getMasterDivision } from '../../../services/masterDivision';
import { getAllMasterCategory, getMasterCategory } from '../../../services/masterCatgegory';
import { getAllMasterSubCategory, getMasterSubCategory } from '../../../services/masterSubCategory';
import { ProductBadgeEnum } from '../../../enums/productBadge';

interface DataMasterProductForUploadCsvType {
  itemcode: string;
  mainGroup: string;
  Division: string;
  Category: string;
  SubCategory: string;
  productNameEn: string;
  productNameLa: string;
  barcodes: string;
}

export const useProductController = () => {
  const [status, setStatus] = useState('ALL');
  const [loadingRefreshProduct, setLoadingRefreshProduct] = useState<boolean>(false);
  const [loadingRefreshProductCategory, setLoadingRefreshProductCategory] =
    useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingFetchDataMore, setLoadingFetchDataMore] = useState<boolean>(false);
  const [data, setData] = useState<MasterProductModel[]>([]);
  const [dataBrand, setDataBrand] = useState<BrandModel[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const [searchProdcutByBarcodeValue, setSearchProductByBarcodeValue] = useState<string>('');

  const [mainGroupValue, setMainGroupValue] = useState<string>('All');
  const [divisionValue, setDivisionValue] = useState<string>('All');
  const [categoryValue, setCategoryValue] = useState<string>('All');
  const [subCategoryValue, setSubCategoryValue] = useState<string>('All');

  const [dataMasterMainGroups, setDataMasterMainGroups] = useState<SuppliesMainGroupName[]>([]);
  const [dataMasterDivisions, setDataMasterDivisions] = useState<SuppliesDivisionModel[]>([]);
  const [dataMasterCategories, setDataMasterCategories] = useState<SuppliesCategoryProduct[]>([]);
  const [dataMasterSubCategories, setDataMasterSubCategories] = useState<
    SuppliesProductSubCategory[]
  >([]);

  const [dataMasterMainGroupsForSelect, setDataMasterMainGroupsForSelect] = useState<
    SuppliesMainGroupName[]
  >([]);
  const [dataMasterDivisionsForSelect, setDataMasterDivisionsForSelect] = useState<
    SuppliesDivisionModel[]
  >([]);
  const [dataMasterCategoriesForSelect, setDataMasterCategoriesForSelect] = useState<
    SuppliesCategoryProduct[]
  >([]);
  const [dataMasterSubCategoriesForSelect, setDataMasterSubCategoriesForSelect] = useState<
    SuppliesProductSubCategory[]
  >([]);

  const [dataMasterProductForUploadCategories, setDataMasterProductForUploadCategories] = useState<
    DataMasterProductForUploadCsvType[]
  >([]);

  const [isSearch, setIsSearch] = useState<boolean>(false);
  const [isInit, setIsInit] = useState<boolean>(false);

  const [selectedData, setSelectedData] = useState<any>(null!);
  const [countAllProduct, setCountAllProduct] = useState<number>(0);

  const [selectedCheckboxId, setSelectedCheckboxId] = useState<string[]>([]);
  const [selectedId, setSelectedId] = useState<string>(null!);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [openMenu, setOpenMenu] = useState(null);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [loadingUploadData, setLoadingUploadData] = useState<boolean>(false);
  const [loadingExportCsvButton, setLoadingExportCsvButton] = useState<boolean>(false);
  const [loadingFilterData, setLoadingFilterData] = useState<boolean>(false);

  const searchRef = useRef<HTMLInputElement>(null!);
  const buttonExportProductForUploadCategoriesRef = createRef<any>();
  const [loadingUploadProductCategories, setLoadingUploadProductCategories] =
    useState<boolean>(false);

  const onChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const handleSearch = (e: any) => {
    setSearchValue(e.target.value);
    setCurrentPage(1);
  };

  const handleSearchProductByBarcode = (e: any) => {
    setSearchProductByBarcodeValue(e.target.value);
  };

  const handleExportCsvProductForUploadCategories = async () => {
    try {
      setLoadingExportCsvButton(true);
      const getDataMasterDivision = await getAllMasterDivision();
      const getDataMasterCategories = await getAllMasterCategory();
      const getDataMasterSubCategories = await getAllMasterSubCategory();
      const resGetAllMasterProducts = await axios.post(PRODUCT_MASTER_FIND_MANY);
      let getDataMasterProducts: MasterProductModel[] = resGetAllMasterProducts?.data;
      if (getDataMasterProducts?.length > 0) {
        if (status !== 'ALL') {
          getDataMasterProducts = getDataMasterProducts.filter((item: MasterProductModel) => {
            const isNullOrEmptyString =
              item.masterMainGroupId === null || item.masterMainGroupId === 'null';

            if (status === 'HAS_CATEGORY') {
              return item.masterMainGroupId && !isNullOrEmptyString;
            } else {
              return !item.masterMainGroupId || isNullOrEmptyString;
            }
          });
        }
        const getDataToUploadCSV = getDataMasterProducts?.map((item: MasterProductModel) => {
          return {
            productNameEn: item?.productNameEn,
            productNameLa: item?.productNameLa,
            itemcode: item?.itemcode,
            barcodes: concatenateStrings(item?.barcodes),
            mainGroup:
              dataMasterMainGroups?.filter((subItem) => subItem?.id === item?.masterMainGroupId)[0]
                ?.main_group_name_en ?? '',
            Division:
              getDataMasterDivision?.filter(
                (subItem) => subItem?.id === item?.masterDivisionNameId
              )[0]?.division_name_en ?? '',
            Category:
              getDataMasterCategories?.filter(
                (subItem) => subItem?.id === item?.masterProductCategoryId
              )[0]?.category_name_en ?? '',
            SubCategory:
              getDataMasterSubCategories?.filter(
                (subItem) => subItem?.id === item?.masterProductSubCategoryId
              )[0]?.sub_category_name_en ?? '',
            quantity: item?.quantity,
            status: item?.isActiveStatus === true ? 'Active' : 'InActive',
          };
        });
        setDataMasterProductForUploadCategories(getDataToUploadCSV);
      } else {
        window.alert('Not found master products');
      }
      // if (buttonExportProductForUploadCategoriesRef.current) {
      //   buttonExportProductForUploadCategoriesRef.current.link.click();
      // }
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingExportCsvButton(false);
    }
  };

  const onOpenMenu = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedId(getId);
    setSelectedData(data?.filter((item) => item?.id === getId)[0]);
  };

  const onDeleteData = () => {
    setData(data?.filter((item) => item?.id !== selectedId));
    setOpenMenu(null!);
  };

  const onDeleteSelectedData = () => {
    let newData = data;
    for (let i = 0; i < selectedCheckboxId.length; i++) {
      newData = newData?.filter((item) => item?.id !== selectedCheckboxId[i]);
    }

    setData(newData);
    setSelectedCheckboxId([]);
  };

  const onSelectCheckBox = (event: any, getId: string) => {
    const selectedIndex = selectedCheckboxId.indexOf(getId);
    let newSelected: any = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedCheckboxId, getId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedCheckboxId.slice(1));
    } else if (selectedIndex === selectedCheckboxId.length - 1) {
      newSelected = newSelected.concat(selectedCheckboxId.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedCheckboxId.slice(0, selectedIndex),
        selectedCheckboxId.slice(selectedIndex + 1)
      );
    }
    setSelectedCheckboxId(newSelected);
  };

  // const onSelectCheckBoxAll = (event: any) => {
  //   if (event.target.checked) {
  //     const newSelecteds: any = filterData.map((n) => n.id);
  //     setSelectedCheckboxId(newSelecteds);
  //     return;
  //   }
  //   setSelectedCheckboxId([]);
  // };

  const handleGetData = async () => {
    try {
      setLoadingFilterData(true);
      const newData = await getProduct({
        take: 30,
        skip: 0,
      });
      const newMainGroup = await getMasterMainGroup();
      const newCountProduct = await getCountMasterProduct();
      setCountAllProduct(newCountProduct);
      setData(newData);
      setDataMasterMainGroups(newMainGroup);
      setCurrentPage(1);
      setIsSearch(false);
      await getProductById('663ca86c6ecf421039b87abd');
      // const [
      //   res,
      //   resGetCountAllProduct,
      //   resMasterMainGroups,
      //   resMasterDivisions,
      //   resMasterCategories,
      //   resMasterSubCategories,
      //   resGetDataBrand,
      // ] = await Promise.all([
      //   axios.post(PRODUCT_MASTER_FIND_MANY, {
      //     take: DEFAULT_FIRST_GET_DATA_AMOUNT,
      //     skip: currentPage,
      //   }),
      //   axios.get(GET_COUNT_MASTER_PRODUCT),
      //   axios.post(MASTER_MAIN_GROUP_FIND_MANY),
      //   axios.post(MASTER_DIVISION_FIND_MANY),
      //   axios.post(MASTER_CATEGORIES_FIND_MANY),
      //   axios.post(MASTER_SUB_CATEGORIES_FIND_MANY),
      //   axios.post(PRODUCTS_BRAND_FIND_MANY),
      // ]);

      // setData(res?.data);
      // setCountAllProduct(resGetCountAllProduct?.data?.data?.All?._all);
      // if (resMasterMainGroups?.data?.length > 0) {
      //   setDataMasterMainGroups(resMasterMainGroups?.data);
      //   setDataMasterMainGroupsForSelect(resMasterMainGroups?.data);
      // }
      // if (resMasterDivisions?.data?.length > 0) {
      //   setDataMasterDivisions(resMasterDivisions?.data);
      // }
      // if (resMasterCategories?.data?.length > 0) {
      //   setDataMasterCategories(resMasterCategories?.data);
      // }
      // if (resMasterSubCategories?.data?.length > 0) {
      //   setDataMasterSubCategories(resMasterSubCategories?.data);
      // }
      // if (resGetDataBrand?.data?.length > 0) {
      //   setDataBrand(resGetDataBrand?.data);
      // }
    } catch (err: any) {
      try {
        window.alert(err?.response?.data?.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoading(false);
      setLoadingFilterData(false);
    }
  };

  const handleRefreshAllProduct = async () => {
    try {
      setLoadingRefreshProduct(true);
      await axios.get(GET_PRODUCT_FROM_SBC);
      window.alert('ສຳເລັດ');
    } catch (err) {
      window.alert('ສຳເລັດ');
      // window.alert('Server error please try again');
    } finally {
      setLoadingRefreshProduct(false);
    }
  };
  const handleRefreshProductCategory = async () => {
    try {
      setLoadingRefreshProductCategory(true);
      await axios.get(REFRESH_PRODUCT_MERCHANT);
      window.alert('ສຳເລັດ');
    } catch (err) {
      window.alert('Server error please try again');
    } finally {
      setLoadingRefreshProductCategory(false);
    }
  };

  const handleUploadProductCategories = async (file: File) => {
    try {
      if (file) {
        setLoadingUploadProductCategories(true);
        const formData: any = new FormData();
        formData.append('fileCsv', file);
        const res = await axios.patch(MASTER_PRODUCT_UPDATE_MASTER_PRODUCT_CATEGORY, formData);
        window.alert(res?.data?.message);
      }
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again later');
      }
    } finally {
      setLoadingUploadProductCategories(false);
    }
  };

  const handleRefetchData = async (id: string) => {
    try {
      const res = await getProductById(id);
      console.log(res);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleFetchDataMore = async () => {
    try {
      if (!isSearch) {
        setLoadingFetchDataMore(true);
        const res = await getProduct({
          take: 30,
          skip: data?.length,
          masterMainGroupId: mainGroupValue !== 'All' ? mainGroupValue : '',
          divisionId: divisionValue !== 'All' ? divisionValue : '',
          categoryId: categoryValue !== 'All' ? categoryValue : '',
          subCategoryId: subCategoryValue !== 'All' ? subCategoryValue : '',
        });
        const newData = [...data, ...res];
        setData(newData);
      }
    } catch (err) {
    } finally {
      setLoadingFetchDataMore(false);
    }
  };

  const handleGetActiveProduct = async (newValue: string) => {
    try {
      setCurrentPage(1);
      setLoadingFilterData(true);
      setIsSearch(true);
      const newData = await getCategoryActiveProduct(newValue === 'HAS_CATEGORY' ? true : false);
      setData(newData);
    } catch (err) {
    } finally {
      setLoadingFilterData(false);
    }
  };

  const handleSearchProduct = async () => {
    try {
      setLoadingFilterData(true);
      setIsSearch(true);
      if (searchValue) {
        setCurrentPage(1);
        const newData = await searchMasterProduct(searchValue);
        setData(newData);
        setStatus('ALL');
      }
    } catch (err) {
    } finally {
      setLoadingFilterData(false);
    }
  };

  const handlePageChange = (event: any, newPage: any) => {
    if (newPage === countPagination) {
      if (!loadingFetchDataMore) {
        handleFetchDataMore();
      }
    }
    setCurrentPage(newPage);
  };

  const handleFilterDataByItemCode = async () => {
    try {
      setLoading(true);
      const res = await axios.post(PRODUCT_MASTER_FIND_MANY, {
        filtter: {
          itemcode: searchRef.current.value,
        },
      });
      if (res?.data?.length > 0) {
        setData(res?.data);
      } else {
        setData([]);
      }
    } catch (err) {
      window.alert('Server error please try again');
    } finally {
      setLoading(false);
    }
  };
  const handleAutoUploadAllProductMerchants = async () => {
    try {
      setLoadingUploadData(true);
      const { data: dataAllMerchants }: { data: MerChantModel[] } = await axios.get(
        MERCHANT_STORE_FIND_MANY
      );

      await Promise.all(
        dataAllMerchants?.map(async (item) => {
          try {
            await axios.get(
              PRODUCT_MASTER_GET_PRODUCT_ON_HAND_FROM_SBC + '?BranchCode=' + item?.merchantCode
            );
          } catch (err) {}
        })
      );

      window.alert('Update Successfully');
    } catch (err) {
      window.alert('Server error please try again');
    } finally {
      setLoadingUploadData(false);
    }
  };

  const handleUploadImages = async (event: any) => {
    try {
      setLoadingUploadData(true);

      const files = Array.from(event.target.files) as File[];
      // for (const item of files) {
      //   const formData = new FormData();
      //   formData.append('mainImage', item);
      //   try {
      //     const getProductId: string = data.filter((subItem: MasterProductModel) =>
      //       subItem.barcodes.includes(removeFileExtension(item?.name))
      //     )[0].id;
      //     await axios.patch(`${MASTER_PRODUCT_UPDATE}?id=${getProductId}`, formData, {
      //       headers: {
      //         'Content-Type': 'multipart/form-data',
      //         Accept: 'multipart/form-data',
      //       },
      //     });
      //   } catch (err) {
      //     // console.log('error=', err);
      //   }
      // }
      // window.alert('upload file successful ' + files?.length + ' files');
      await uploadMultipleImage(files);
    } catch (err) {
      // console.log('error=', err);
    } finally {
      setLoadingUploadData(false);
    }
  };

  const handleClickViewDataButton = () => {
    setOpenForm(true);
    setOpenMenu(null!);
    setSelectedData(data?.filter((item) => item?.id === selectedId)[0]);
  };

  const handleMasterValueChange = async (e: any) => {
    try {
      setIsSearch(false);
      setLoadingFilterData(true);
      setMainGroupValue(e.target.value);
      if (e.target.value === 'All') {
        setDataMasterDivisions([]);
        const newData = await getProduct({
          take: 30,
          skip: 0,
        });
        setData(newData);
      } else {
        const getDivision = await getMasterDivision(e.target.value);
        const newData = await getProduct({
          take: 30,
          skip: 0,
          masterMainGroupId: e.target.value,
        });
        setData(newData);
        setDataMasterDivisions(getDivision);
      }

      setDataMasterCategories([]);
      setDataMasterSubCategories([]);
      setDivisionValue('All');
      setCategoryValue('All');
      setSubCategoryValue('All');
      setCurrentPage(1);
    } catch {
    } finally {
      setLoadingFilterData(false);
    }
  };

  const handleMasterDivisionValueChange = async (e: any) => {
    try {
      setIsSearch(false);
      setLoadingFilterData(true);
      setDivisionValue(e.target.value);
      if (e.target.value === 'All') {
        setDataMasterCategories([]);
        const newData = await getProduct({
          take: 30,
          skip: 0,
          masterMainGroupId: mainGroupValue,
        });
        setData(newData);
      } else {
        const getMasterCategoryData = await getMasterCategory(e.target.value);
        const newData = await getProduct({
          take: 30,
          skip: 0,
          masterMainGroupId: mainGroupValue,
          divisionId: e.target.value,
        });
        setData(newData);
        setDataMasterCategories(getMasterCategoryData);
      }
      setDataMasterSubCategories([]);
      setCategoryValue('All');
      setSubCategoryValue('All');
      setCurrentPage(1);
    } catch {
    } finally {
      setLoadingFilterData(false);
    }
  };

  const handleMasterCategoryValueChange = async (e: any) => {
    try {
      setIsSearch(false);
      setLoadingFilterData(true);
      setCategoryValue(e.target.value);
      if (e.target.value === 'All') {
        setDataMasterSubCategories([]);
        const newData = await getProduct({
          take: 30,
          skip: 0,
          masterMainGroupId: mainGroupValue,
          divisionId: divisionValue,
        });
        setData(newData);
      } else {
        const newMasterSubCategory = await getMasterSubCategory(e.target.value);
        const newData = await getProduct({
          take: 30,
          skip: 0,
          masterMainGroupId: mainGroupValue,
          divisionId: divisionValue,
          categoryId: e.target.value,
        });
        setData(newData);
        setDataMasterSubCategories(newMasterSubCategory);
      }
      setSubCategoryValue('All');
      setCurrentPage(1);
    } catch {
    } finally {
      setLoadingFilterData(false);
    }
  };

  const handleMasterSubCategoryValueChange = async (e: any) => {
    try {
      setIsSearch(false);
      setLoadingFilterData(true);
      setSubCategoryValue(e.target.value);
      if (e.target.value === 'All') {
        const newData = await getProduct({
          take: 30,
          skip: 0,
          masterMainGroupId: mainGroupValue,
          divisionId: divisionValue,
          categoryId: categoryValue,
        });
        setData(newData);
      } else {
        const newData = await getProduct({
          take: 30,
          skip: 0,
          masterMainGroupId: mainGroupValue,
          divisionId: divisionValue,
          categoryId: categoryValue,
          subCategoryId: e.target.value,
        });
        setData(newData);
      }
      setCurrentPage(1);
    } catch {
    } finally {
      setLoadingFilterData(false);
    }
  };

  // filter variables
  const filterDataByStatus = data.filter((item) => {
    const isNullOrEmptyString =
      item.masterMainGroupId === null || item.masterMainGroupId === 'null';

    if (status === 'ALL') {
      return true;
    } else if (status === 'HAS_CATEGORY') {
      return item.masterMainGroupId && !isNullOrEmptyString;
    } else {
      return !item.masterMainGroupId || isNullOrEmptyString;
    }
  });

  const filterDataByCategory = filterDataByStatus.filter((item) => {
    if (
      mainGroupValue === 'All' &&
      divisionValue === 'All' &&
      categoryValue === 'All' &&
      subCategoryValue === 'All'
    ) {
      return true;
    } else if (
      mainGroupValue !== 'All' &&
      divisionValue === 'All' &&
      categoryValue === 'All' &&
      subCategoryValue === 'All'
    ) {
      return item?.masterMainGroupId === mainGroupValue;
    } else if (
      mainGroupValue !== 'All' &&
      divisionValue !== 'All' &&
      categoryValue === 'All' &&
      subCategoryValue === 'All'
    ) {
      return (
        item?.masterMainGroupId === mainGroupValue && item?.masterDivisionNameId === divisionValue
      );
    } else if (
      mainGroupValue !== 'All' &&
      divisionValue !== 'All' &&
      categoryValue !== 'All' &&
      subCategoryValue === 'All'
    ) {
      return (
        item?.masterMainGroupId === mainGroupValue &&
        item?.masterDivisionNameId === divisionValue &&
        item?.masterProductCategoryId === categoryValue
      );
    } else if (
      mainGroupValue !== 'All' &&
      divisionValue !== 'All' &&
      categoryValue !== 'All' &&
      subCategoryValue !== 'All'
    ) {
      return (
        item?.masterMainGroupId === mainGroupValue &&
        item?.masterDivisionNameId === divisionValue &&
        item?.masterProductCategoryId === categoryValue &&
        item?.masterProductSubCategoryId === subCategoryValue
      );
    } else {
      return false;
    }
  });

  // const filterData = filterDataByCategory.filter(
  //   (item) =>
  //     item?.itemcode.toLowerCase()?.includes(searchValue.toLowerCase()) ||
  //     item?.itemcode.toLowerCase()?.includes(searchValue.toLowerCase()) ||
  //     item?.productNameEn.toLowerCase()?.includes(searchValue.toLowerCase()) ||
  //     item?.productNameLa.toLowerCase()?.includes(searchValue.toLowerCase()) ||
  //     concatenateStrings(item?.barcodes)
  //       .toString()
  //       .toLowerCase()
  //       ?.includes(searchValue.toLowerCase())
  // );

  const rows = data.slice(
    (currentPage - 1) * DEFAULT_ROWS_PER_PAGE,
    currentPage * DEFAULT_ROWS_PER_PAGE
  );
  const countPagination = Math.ceil(data.length / DEFAULT_ROWS_PER_PAGE);
  const isSearchNotFound: boolean = !data.length;

  const handleStatusChange = (newValue: string) => {
    setStatus(newValue);
    if (newValue !== 'ALL') {
      handleGetActiveProduct(newValue);
    } else {
      handleGetData();
    }
  };

  // useEffect

  useEffect(() => {
    if (isInit && dataMasterProductForUploadCategories.length > 0) {
      if (buttonExportProductForUploadCategoriesRef.current) {
        buttonExportProductForUploadCategoriesRef.current.link.click();
      }
    } else {
      setIsInit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataMasterProductForUploadCategories]);

  useEffect(() => {
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    selectedCheckboxId,
    onDeleteData,
    // filterData,
    // onSelectCheckBoxAll,
    rows,
    openMenu,
    onCloseMenu: () => setOpenMenu(null),
    onOpenMenu,
    onOpenForm: () => {
      setOpenMenu(null);
      setOpenForm(true);
    },
    onCloseForm: () => setOpenForm(false),
    openForm,
    onChangePage,
    currentPage,
    isSearchNotFound,
    onSelectCheckBox,
    onDeleteSelectedData,
    countPagination,
    loading,
    handlePageChange,
    loadingFetchDataMore,
    selectedData,
    countAllProduct,
    dataBrand,
    dataMasterMainGroups,
    dataMasterDivisions,
    dataMasterCategories,
    dataMasterSubCategories,
    handleGetData,
    searchRef,
    handleFilterDataByItemCode,
    handleClickViewDataButton,
    handleRefetchData,
    buttonExportProductForUploadCategoriesRef,
    handleExportCsvProductForUploadCategories,
    loadingUploadData,
    dataMasterProductForUploadCategories,
    handleUploadProductCategories,
    loadingUploadProductCategories,
    handleSearchProductByBarcode,
    handleUploadImages,
    handleAutoUploadAllProductMerchants,
    searchValue,
    setSearchValue,
    status,
    handleStatusChange,
    mainGroupValue,
    setMainGroupValue,
    divisionValue,
    setDivisionValue,
    categoryValue,
    setCategoryValue,
    subCategoryValue,
    setSubCategoryValue,
    dataMasterMainGroupsForSelect,
    dataMasterDivisionsForSelect,
    dataMasterCategoriesForSelect,
    dataMasterSubCategoriesForSelect,
    handleMasterValueChange,
    handleMasterDivisionValueChange,
    handleMasterCategoryValueChange,
    handleMasterSubCategoryValueChange,
    loadingRefreshProduct,
    handleRefreshAllProduct,
    handleSearch,
    handleRefreshProductCategory,
    loadingRefreshProductCategory,
    loadingFilterData,
    handleSearchProduct,
    // filterDivisionData
    loadingExportCsvButton,
    setData,
    data,
  };
};
